import { useState, useEffect } from 'react'
import getSuffixes, { SuffixOption } from '@api/getSuffixes'

function useSuffixOptions(): [SuffixOption[], boolean] {
  const [suffixes, setSuffixes] = useState<SuffixOption[]>([])
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      const suffixList = await getSuffixes()
      setSuffixes(suffixList)
      setIsLoading(false)
    }
    fetchData()
  }, [])
  return [suffixes, isLoading]
}

export default useSuffixOptions
